import Vue from "vue";
const instance = new Vue();
const watch = instance.$watch.bind(instance);

export { instance, watch };
